import { type FC } from "react";

import { Button, Colors } from "@snapchat/snap-design-system";
import { PencilIcon } from "@snapchat/snap-design-system-icons";

import { CancelButtonCta, EditButtonCta, UpdateButtonCta } from "../../../messages.generated";

import { buttonIcon, buttonStyle, footer } from "./ApiSettingsCard.styles";

interface ApiSettingsCardFooterProps {
    editMode: boolean;
    onEditButtonClick: () => void;

    onCancel?: () => void;
    onAction?: () => void;
    isActionDisabled: boolean;
    isLoading?: boolean;
}

export const ApiSettingsCardFooter: FC<ApiSettingsCardFooterProps> = ({
    editMode,
    onAction,
    onCancel,
    isActionDisabled,
    onEditButtonClick,
    isLoading,
}) => {
    if (editMode) {
        return (
            <div className={footer}>
                <Button onClick={onCancel} data-testid="api-settings-card-cancel-button">
                    <CancelButtonCta />
                </Button>
                <Button
                    data-testid="api-settings-card-update-button"
                    onClick={onAction}
                    type="primary"
                    className={buttonStyle}
                    isDisabled={isActionDisabled}
                    isPending={isLoading}
                >
                    <UpdateButtonCta />
                </Button>
            </div>
        );
    }

    return (
        <div className={footer}>
            <Button
                data-testid="api-settings-edit-button"
                onClick={onEditButtonClick}
                type="primary"
                className={buttonStyle}
            >
                <PencilIcon className={buttonIcon} fill={Colors.WHITE} />
                <EditButtonCta />
            </Button>
        </div>
    );
};
